import React, { useState } from "react";
import { Auth } from "aws-amplify";
import { Link, useHistory } from "react-router-dom";
import { FormGroup } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import { useAppContext } from "../libs/contextLib";
import { useFormFields } from "../libs/hooksLib";
import { onError } from "../libs/errorLib";
import { FormArea, FieldLabel, ThemedFormControl } from "../components/FormStyles";

export default function Signup() {
  const [fields, handleFieldChange] = useFormFields({
    email: "",
    password: "",
    confirmPassword: "",
    confirmationCode: ""
  });
  const history = useHistory();
  const { setSignupResult } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);

  function validateForm() {
    return (
      fields.email.length > 0 &&
      fields.password.length > 0 &&
      fields.password === fields.confirmPassword
    );
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setIsLoading(true);

    try {
      const signupResult = await Auth.signUp({
        username: fields.email,
        password: fields.password
      });
      setIsLoading(false);
      setSignupResult(signupResult);
      history.push("/signup-confirm");
    } catch (e) {
      setIsLoading(false);
      onError(e);
    }
  }

  function renderForm() {
    return (
      <FormArea>
        <h1>Welcome!</h1>
        <form onSubmit={handleSubmit}>
          <FormGroup controlId="email" bsSize="large">
            <FieldLabel>Email</FieldLabel>
            <ThemedFormControl
              autoFocus
              type="email"
              value={fields.email}
              onChange={handleFieldChange}
            />
          </FormGroup>
          <FormGroup controlId="password" bsSize="large">
            <FieldLabel>Password</FieldLabel>
            <ThemedFormControl
              type="password"
              value={fields.password}
              onChange={handleFieldChange}
            />
          </FormGroup>
          <FormGroup controlId="confirmPassword" bsSize="large">
            <FieldLabel>Confirm Password</FieldLabel>
            <ThemedFormControl
              type="password"
              onChange={handleFieldChange}
              value={fields.confirmPassword}
            />
          </FormGroup>
          <LoaderButton
            block
            type="submit"
            bsSize="large"
            isLoading={isLoading}
            disabled={!validateForm()}
          >
            Signup
        </LoaderButton>
          <p>
            <Link to="/signup-confirm">
              I have an e-mail confirmation code.
          </Link>
          </p>
        </form>
      </FormArea>
    );
  }

  return (
    <div className="Signup">
      {renderForm()}
    </div>
  );
}
